/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ZentraleBerechtigung { 
    ist_manager?: boolean;
    ist_bearbeiter?: boolean;
    ist_leser?: boolean;
}

